import { categoriesService, regionsService, campaignsService, countriesService, lenguagesService, tagsService } from '@/_services'
import i18n from '@/_helpers/i18n';
 
const getDefaultState = () => {
  return {
    loading: false,
    all: [],
    completeLoading: false,
    completeLoadingAgency: false,
    completeLoadingTarget: false,
    completeLoadingCalendar: false,
    completeLoadingTemplate: false,
    contractListLoaded: false,
    completeLoadingOpp: false
  }
}

const REGIONS = 'regions';
const COUNTRIES = 'countries';
const CATEGORIES_GOOGLE = 'categories_google';
const CATEGORIES_SEARCH_WORDS = 'categories_search_words';
const CATEGORIES_SEARCH_FUNCTION = 'categories_search_function';
const CATEGORIES_SEARCH_LEVEL = 'categories_search_level';
const CATEGORIES_GOOGLE_ALL = 'categories_google_all';
const PROFILE_COUNTRIES = 'profile_countries';
const TIMEZONES = 'timezones';
const LANGUAGES = 'languages';
const AVAILABLE_TOKENS = 'available_tokens';
const PARAMETERS_TF = 'parameters_tf';

const getCountriesFromStorage = () => {
  try {
    const sessionCountries = JSON.parse(sessionStorage.getItem(COUNTRIES));
    if (sessionCountries && sessionCountries.length > 0) {
      return sessionCountries;
    }

    const localCountries = JSON.parse(localStorage.getItem(COUNTRIES));
    if (localCountries && localCountries.length > 0) {
      sessionStorage.setItem(COUNTRIES, JSON.stringify(localCountries));
      return localCountries;
    }
  } catch (e) {
    return null;
  }

  return null;
}

const getAllOptionsSession= () => {
  try {
    return {
      countries: getCountriesFromStorage(),
      regions: JSON.parse(sessionStorage.getItem(REGIONS)),
      categories_google: JSON.parse(sessionStorage.getItem(CATEGORIES_GOOGLE)),
      categories_google_all: JSON.parse(sessionStorage.getItem(CATEGORIES_GOOGLE_ALL)),
      categories_search_words: JSON.parse(sessionStorage.getItem(CATEGORIES_SEARCH_WORDS)),
      categories_search_function: JSON.parse(sessionStorage.getItem(CATEGORIES_SEARCH_FUNCTION)),
      categories_search_level: JSON.parse(sessionStorage.getItem(CATEGORIES_SEARCH_LEVEL)),
      param_5: JSON.parse(sessionStorage.getItem('param_5')),
      param_4: JSON.parse(sessionStorage.getItem('param_4')),
      param_10: JSON.parse(sessionStorage.getItem('param_10')),
      param_17: JSON.parse(sessionStorage.getItem('param_17')),
      parameters_tf: JSON.parse(sessionStorage.getItem(PARAMETERS_TF)),
      profile_countries: JSON.parse(sessionStorage.getItem(PROFILE_COUNTRIES)),
      timezones: JSON.parse(sessionStorage.getItem(TIMEZONES)),
      languages: JSON.parse(sessionStorage.getItem(LANGUAGES)),
      available_tokens: JSON.parse(sessionStorage.getItem(AVAILABLE_TOKENS)),
      tag_2: JSON.parse(sessionStorage.getItem("tag_2")),
    }
  } catch (e) {
    return {
      countries: {},
      regions: {},
      categories_google: {},
      categories_google_all: {},
      categories_search_words: {},
      categories_search_function: {},
      categories_search_level: {},
      param_5: {},
      param_4: {},
      param_10: {},
      param_17: {},
      parameters_tf: {},
      profile_countries: {},
      timezones: {},
      languages: {},
      available_tokens: {},
      tag_2: {},
    }
  }
}

const allOptionsSession = getAllOptionsSession()


const getTranslates = (items, field) => {
  return items
    .map(function (element) {
      if (element.translated === undefined) {
        element[field] = i18n.t("lang.optionlist." + element[field].replace(/\s/g, ''));
        element.translated = true;
      }
      return element;
    });
}
// initial state
const state = getDefaultState()

const actions = {

  getTimezonesParam({ dispatch, commit }, args) {
    dispatch('getTimezones', args)
  },

  getCalendarParam({ dispatch, commit }, args) {
    dispatch('getTimezones', args)
    dispatch('getLanguages', args)
  },

  getAllOppParams({ dispatch, commit }, args) {
    dispatch('getAvailableTokens', args)
  },

  getAllTargetParams({ dispatch, commit }, args) {
    // 1
    dispatch('getCategoriesGoogle', args)
    // 2
    dispatch('getCategoriesGoogleAll', args)
    // 3
    dispatch('getCategoriesSearchFunction', args)
    // 4
    dispatch('getCategoriesSearchLevel', args)
    // 5
    dispatch('getRegions', args)
    // 6
    dispatch('getCountries', args)
    // 7
    dispatch('getProfileCountries', args)
    // 12
    dispatch('getTimezones', args)
    // 13
    dispatch('getLanguages', args)
    // 14
    dispatch('getAvailableTokens', args)
    // 15
    dispatch('getTags', { tagTypeId: 2 })
  },
  getAllAgencyParams({ dispatch, commit }, args) {
    // state.totalLoadingAll is the total dispatchs
    // 1
    dispatch('getCategoriesGoogle', args)
    // 2
    dispatch('getCategoriesGoogleAll', args)
    // 3
    dispatch('getCategoriesSearchFunction', args)
    // 4
    dispatch('getCategoriesSearchLevel', args)
    // 5
    dispatch('getRegions', args)
    // 6
    dispatch('getCountries', args)
    // 7
    dispatch('getParametersOptions', { parameterTypeId: 5 })
    // 8
    dispatch('getParametersOptions', { parameterTypeId: 10 })
    // 9
    dispatch('getParametersOptions', { parameterTypeId: 17 })
    // 10
    dispatch('getParametersOptions', { parameterTypeId: 4 })
    // 11
    dispatch('getProfileCountries', args)
    // 12
    dispatch('getTimezones', args)
    // 13
    dispatch('getLanguages', args)
    // 13
    dispatch('getAvailableTokens', args)
  },

  getAll({ dispatch, commit }, args) {
    return new Promise((resolve, reject) => {
      // state.totalLoadingAll is the total dispatchs
      // 1
      dispatch('getCategoriesGoogle', args)
      // 2
      dispatch('getCategoriesGoogleAll', args)
      // 3
      dispatch('getCategoriesSearchFunction', args)
      // 4
      dispatch('getCategoriesSearchLevel', args)
      // 5
      dispatch('getRegions', args)
      // 6
      dispatch('getCountries', args)
      // 7
      dispatch('getParametersOptions', { parameterTypeId: 5 })
      // 8
      dispatch('getParametersOptions', { parameterTypeId: 10 })
      // 9
      dispatch('getParametersOptions', { parameterTypeId: 17 })
      // 10
      dispatch('getAvailableTokens', args)
      // 11
      dispatch('getParametersTypes', args)
      // 12
      dispatch('getParametersOptions', { parameterTypeId: 4 })
      // 13
      dispatch('getProfileCountries', args)
      // 14
      dispatch('getTimezones', args)
      // 15
      dispatch('getLanguages', args)
      // 16
      dispatch('getTags', { tagTypeId: 2 })
      resolve("ok")

    })
  },

  startLoadingAll({ dispatch, commit }, args) {
    commit('startLoadingAll')
  },
  getOptions({ dispatch, commit }, args) {
    args.forEach((item, key) => {
      switch (item) {
        case "categories_google_all":
          dispatch('getCategoriesGoogleAll', args)
          break;
        case "regions":
          dispatch('getRegions', args)
          break;
        case "categories_search_level":
          dispatch('getCategoriesSearchLevel', args)
          break;
        case "categories_search_function":
          dispatch('getCategoriesSearchFunction', args)
          break;
        case "countries":
          dispatch('getCountries', args)
          break;
      }
    })
  },
 
  getCategoriesGoogle({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[CATEGORIES_GOOGLE]) {
      categoriesService
        .getAll()
        .then(
          (response) => {
            if (response.length > 0) {
              sessionStorage.setItem(CATEGORIES_GOOGLE, JSON.stringify(response));
              commit('getAllSuccess', [response, CATEGORIES_GOOGLE])
              commit('finishLoading')
            }
          }
        )
    } else {
      commit('getAllSuccess', [allOptionsSession[CATEGORIES_GOOGLE], CATEGORIES_GOOGLE])
      commit('finishLoading')
    }
  },

  getCategoriesGoogleAll({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[CATEGORIES_GOOGLE_ALL]) {
      categoriesService
        .getAllGoogle()
        .then(
          (response) => {
            if (response.length > 0) {
              let translatedList = getTranslates(response, "label");
              allOptionsSession[CATEGORIES_GOOGLE_ALL] = translatedList
              sessionStorage.setItem(CATEGORIES_GOOGLE_ALL, JSON.stringify(translatedList));
              commit('getAllSuccess', [translatedList, CATEGORIES_GOOGLE_ALL])
              commit('finishLoading')
            }
          }
        )
    } else {
      commit('getAllSuccess', [allOptionsSession[CATEGORIES_GOOGLE_ALL], CATEGORIES_GOOGLE_ALL])
      commit('finishLoading')
    }
  },

  getCategoriesSearchWords({ commit }, args) {
      commit('startLoading')
    if (!allOptionsSession[CATEGORIES_SEARCH_WORDS]) {
      categoriesService
        .getCategoriesSearch()
        .then(
          (response) => {
            if (response.length > 0) {
              sessionStorage.setItem(CATEGORIES_SEARCH_WORDS, JSON.stringify(response));
              commit('getAllSuccess', [response, CATEGORIES_SEARCH_WORDS])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[CATEGORIES_SEARCH_WORDS], CATEGORIES_SEARCH_WORDS])
      commit('finishLoading')
    }
  },

  getCategoriesSearchFunction({ commit }, args) {
      commit('startLoading')
    if (!allOptionsSession[CATEGORIES_SEARCH_FUNCTION]) {
      categoriesService
        .getCategoriesSearchFunction()
        .then(
          (response) => {
            if (response.length > 0) {
              let translatedList = getTranslates(response, "label");
              allOptionsSession[CATEGORIES_SEARCH_FUNCTION] = translatedList
              sessionStorage.setItem(CATEGORIES_SEARCH_FUNCTION, JSON.stringify(translatedList));
              commit('getAllSuccess', [translatedList, CATEGORIES_SEARCH_FUNCTION])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[CATEGORIES_SEARCH_FUNCTION], CATEGORIES_SEARCH_FUNCTION])
      commit('finishLoading')
    }
  },

  getCategoriesSearchLevel({ commit }, args) {
      commit('startLoading')
    if (!allOptionsSession[CATEGORIES_SEARCH_LEVEL]) {
      categoriesService
        .getCategoriesSearchLevel()
        .then(
          (response) => {
            if (response.length > 0) {
              allOptionsSession[CATEGORIES_SEARCH_LEVEL] = response
              sessionStorage.setItem(CATEGORIES_SEARCH_LEVEL, JSON.stringify(response));
              commit('getAllSuccess', [response, CATEGORIES_SEARCH_LEVEL])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[CATEGORIES_SEARCH_LEVEL], CATEGORIES_SEARCH_LEVEL])
      commit('finishLoading')
    }
  },

  getRegions({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[REGIONS] || allOptionsSession[REGIONS].length == 0) {
      regionsService
        .getHierarchy()
        .then(
          (response) => {
            allOptionsSession[REGIONS] = response
            sessionStorage.setItem(REGIONS, JSON.stringify(response));
            commit('getAllSuccess', [response, REGIONS])
            commit('finishLoading')

          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[REGIONS], REGIONS])
      commit('finishLoading')
    }
  },

  getCountries({ commit }, args) {
    commit('startLoading')
    const cachedCountries = getCountriesFromStorage();

    if (cachedCountries && cachedCountries.length > 0) {
      allOptionsSession[COUNTRIES] = cachedCountries
      commit('getAllSuccess', [cachedCountries, COUNTRIES])
      commit('finishLoading')
      return;
    }

    if (!allOptionsSession[COUNTRIES]) {
      regionsService
        .getCountries()
        .then(
          (response) => {
            if (response.length > 0) {
              allOptionsSession[COUNTRIES] = response
              sessionStorage.setItem(COUNTRIES, JSON.stringify(response));
              localStorage.setItem(COUNTRIES, JSON.stringify(response));
              commit('getAllSuccess', [response, COUNTRIES])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[COUNTRIES], COUNTRIES])
      commit('finishLoading')
    }
  },

  getParametersOptions({ commit }, { parameterTypeId }) {
    let param = 'param_' + parameterTypeId
    commit('startLoading')
    if (!allOptionsSession[param]) {
      campaignsService
        .getParameterTypesOptions(parameterTypeId)
        .then(
          (response) => {
            if (response.length > 0) {
              response.forEach(item => {
                item.label = item.name;
                if (item.label == "Groupe National" || item.label == "Groupe International" || item.label == "Succursale" || item.label == "Franchisé") {
                  item.isDisabled = true;
                }
              });
            }
            sessionStorage.setItem(param, JSON.stringify(response));
            commit('getAllSuccess', [response, param])
            commit('finishLoading')
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[param], param])
      commit('finishLoading')
    }
  },

  getParametersTypes({ commit }) {
    commit('startLoading')
    if (!allOptionsSession[PARAMETERS_TF]) {
      campaignsService
        .getParameterTypes()
        .then(
          (response) => {
            sessionStorage.setItem(PARAMETERS_TF, JSON.stringify(response));
            commit('getAllSuccess', [response, PARAMETERS_TF])
            commit('finishLoading')
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[PARAMETERS_TF], PARAMETERS_TF])
      commit('finishLoading')
    }
  },

  getAvailableTokens({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[AVAILABLE_TOKENS]) {
      campaignsService
        .getAvailableTokens()
        .then(
          (response) => {
            sessionStorage.setItem(AVAILABLE_TOKENS, JSON.stringify(response));
            commit('getAllSuccess', [response, AVAILABLE_TOKENS])
            commit('finishLoading')
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[AVAILABLE_TOKENS], AVAILABLE_TOKENS])
      commit('finishLoading')
    }
  },

  getProfileCountries({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[PROFILE_COUNTRIES]) {
      countriesService
        .getAll()
        .then(
          (response) => {
            if (response.length > 0) {
              sessionStorage.setItem(PROFILE_COUNTRIES, JSON.stringify(response));
              commit('getAllSuccess', [response, PROFILE_COUNTRIES])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[PROFILE_COUNTRIES], PROFILE_COUNTRIES])
      commit('finishLoading')
    }
  },

  getTimezones({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[TIMEZONES]) {
      regionsService
        .getTimezones()
        .then(
          (response) => {
            if (response.length > 0) {
              allOptionsSession[TIMEZONES] = response
              sessionStorage.setItem(TIMEZONES, JSON.stringify(response));
              commit('getAllSuccess', [response, TIMEZONES])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[TIMEZONES], TIMEZONES])
      commit('finishLoading')
    }
  },

  getLanguages({ commit }, args) {
    commit('startLoading')
    if (!allOptionsSession[LANGUAGES]) {
      lenguagesService.getAll().then((response) => {
        if (response.length > 0) {
          allOptionsSession[LANGUAGES] = response
          sessionStorage.setItem(LANGUAGES, JSON.stringify(response));
          commit('getAllSuccess', [response, LANGUAGES])
          commit('finishLoading')
        }
      }
      );
    } else {
      commit('getAllSuccess', [allOptionsSession[LANGUAGES], LANGUAGES])
      commit('finishLoading')
    }
  },

  getTags({ commit }, { tagTypeId }) {
    let tag = 'tag_' + tagTypeId
    commit('startLoading')
    if (!allOptionsSession[tag]) {
      tagsService
        .getTags(tagTypeId)
        .then(
          (response) => {

            if (response.length > 0) {
              let translatedList = getTranslates(response, "name");
              sessionStorage.setItem(tag, JSON.stringify(translatedList));
              commit('getAllSuccess', [translatedList, tag])
              commit('finishLoading')
            }
          }
        );
    } else {
      commit('getAllSuccess', [allOptionsSession[tag], tag])
      commit('finishLoading')
    }
  },
}

const mutations = {
  getAllSuccess(state, data) {
    let name_input = data[1];
    state.all[name_input] = { data: data[0] };
  },
  startLoading(state) {
    state.loading = true;
  }, 
  startLoadingAll(state) {
  },
  finishLoading(state) {
    state.loading = false;
    state.totalLoading++;
    state.totalLoadingAgency++;
    
    state.completeLoadingTarget = allOptionsSession[COUNTRIES] != null &&
    allOptionsSession[CATEGORIES_GOOGLE_ALL] !== null &&
    allOptionsSession[CATEGORIES_SEARCH_FUNCTION] !== null &&
    allOptionsSession[CATEGORIES_SEARCH_LEVEL] !== null &&
    allOptionsSession[REGIONS] !== null
    state.completeLoadingCalendar = allOptionsSession[LANGUAGES] != null &&
    allOptionsSession[TIMEZONES] !== null
    
    state.completeLoadingAgency = 
    allOptionsSession[LANGUAGES] !== undefined &&
    allOptionsSession[TIMEZONES] !== undefined &&
    allOptionsSession[PROFILE_COUNTRIES] !== undefined &&
    allOptionsSession[COUNTRIES] !== undefined &&
    allOptionsSession[REGIONS] !== undefined &&
    allOptionsSession[CATEGORIES_GOOGLE] !== undefined &&
    allOptionsSession[CATEGORIES_GOOGLE_ALL] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_WORDS] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_FUNCTION] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_LEVEL] !== undefined &&
    allOptionsSession['param_5'] !== undefined &&
    allOptionsSession['param_10'] !== undefined &&
    allOptionsSession['param_17'] !== undefined;
             
    state.completeLoading = 
    allOptionsSession[LANGUAGES] !== undefined &&
    allOptionsSession[TIMEZONES] !== undefined &&
    allOptionsSession[PROFILE_COUNTRIES] !== undefined &&
    allOptionsSession[COUNTRIES] !== undefined &&
    allOptionsSession[REGIONS] !== undefined &&
    allOptionsSession[CATEGORIES_GOOGLE] !== undefined &&
    allOptionsSession[CATEGORIES_GOOGLE_ALL] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_WORDS] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_FUNCTION] !== undefined &&
    allOptionsSession[CATEGORIES_SEARCH_LEVEL] !== undefined &&
    allOptionsSession['param_5'] !== undefined &&
    allOptionsSession['param_10'] !== undefined &&
    allOptionsSession['param_17'] !== undefined &&
    allOptionsSession['param_4'] !== undefined &&
    allOptionsSession[PARAMETERS_TF] !== undefined &&
    allOptionsSession[AVAILABLE_TOKENS] !== undefined;

    // set contractListLoaded
    state.contractListLoaded = allOptionsSession[CATEGORIES_GOOGLE_ALL] !== undefined &&
      allOptionsSession[CATEGORIES_SEARCH_WORDS] !== undefined &&
      allOptionsSession[CATEGORIES_SEARCH_FUNCTION] !== undefined &&
      allOptionsSession[CATEGORIES_SEARCH_LEVEL] !== undefined &&
      allOptionsSession[COUNTRIES] !== undefined &&
      allOptionsSession[REGIONS] !== undefined;

      state.completeLoadingTemplate = allOptionsSession[LANGUAGES] !== undefined &&
      allOptionsSession[AVAILABLE_TOKENS] !== undefined;

      state.completeLoadingOpp = allOptionsSession[AVAILABLE_TOKENS] !== undefined;

  },
}

export const optionsList = {
  namespaced: true,
  state,
  actions,
  mutations,
}